module.exports = __webpack_public_path__ + "static/images/ui/ui-icons_cccccc_256x240.png";